/**
 * auhasard/livre-extrait-pdf — view script
 *
 * Interactivity API store: handles opening and closing the PDF modal.
 */

import { store, getContext } from '@wordpress/interactivity';

store( 'auhasard/livre-extrait-pdf', {
	actions: {
		openModal() {
			console.log('hi')
			const context = getContext();
			context.isOpen = true;
			document.body.style.overflow = 'hidden';
		},
		closeModal() {
			const context = getContext();
			context.isOpen = false;
			document.body.style.overflow = '';
		},
		handleKeydown( event ) {
			if ( event.key === 'Escape' ) {
				const context = getContext();
				if ( context.isOpen ) {
					context.isOpen = false;
					document.body.style.overflow = '';
				}
			}
		},
	},
} );
